export const HOME = {
  emergentLink: "emergent-link",
};

export const LANDING = {
  // Nav
  nav: "site-nav",
  navLogo: "nav-logo",
  navAbout: "nav-link-about",
  navServices: "nav-link-services",
  navListings: "nav-link-listings",
  navAreas: "nav-link-areas",
  navContact: "nav-link-contact",
  navCallBtn: "nav-call-btn",

  // Hero
  hero: "hero-section",
  heroH1: "hero-h1",
  heroAppraisalBtn: "hero-appraisal-btn",
  heroCallBtn: "hero-call-btn",
  heroPortrait: "hero-portrait",

  // About
  about: "about-section",
  aboutH2: "about-h2",

  // Services
  services: "services-section",
  serviceCard: "service-card",

  // Listings
  listings: "listings-section",
  listingCard: "listing-card",

  // Areas
  areas: "areas-section",
  areaItem: "area-item",

  // Testimonials
  testimonials: "testimonials-section",
  testimonialCard: "testimonial-card",

  // Contact
  contact: "contact-section",
  contactForm: "contact-form",
  contactName: "contact-form-name",
  contactEmail: "contact-form-email",
  contactPhone: "contact-form-phone",
  contactAddress: "contact-form-address",
  contactMessage: "contact-form-message",
  contactSubmit: "contact-form-submit",
  contactSuccess: "contact-form-success",

  // Footer
  footer: "site-footer",
  footerInstagram: "footer-instagram",
  footerEmail: "footer-email",
  footerPhone: "footer-phone",
};
